import { render } from "./AiTestReport.vue?vue&type=template&id=41b40856&scoped=true&ts=true"
import script from "./AiTestReport.vue?vue&type=script&lang=ts"
export * from "./AiTestReport.vue?vue&type=script&lang=ts"

import "./AiTestReport.vue?vue&type=style&index=0&id=41b40856&scoped=true&lang=css"
import "./AiTestReport.vue?vue&type=style&index=1&id=41b40856&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b40856"]])

export default __exports__